import type { MapLegendEntry } from '@/lib/api/map';

export function filterLegendEntries(
  entries: MapLegendEntry[],
  query: string,
): MapLegendEntry[] {
  const q = query.trim().toLowerCase();
  if (!q) {
    return entries;
  }
  return entries.filter(
    (entry) =>
      entry.label.toLowerCase().includes(q) ||
      entry.code.toLowerCase().includes(q),
  );
}
